import $ from 'jquery';
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import { ActivityControllerUIClient, CellClient, DutyClient, DutyNameWithCellIds } from "../../backend/backendapi";
import { CellTree } from '../../cell/cell.model';
import { mapTree } from '../../cell/cell.util';

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'CreateActivityWithDutyAndCellModal',
    components: {
        vSelect
    }
})
export default class CreateActivityWithDutyAndCellModal extends Vue {
    @Prop({ required: true })
    readonly modalId!: string;

    private duties: DutyNameWithCellIds[] = [];
    private cellTree: CellTree[] = [];

    private dutyId: number | null = null;
    private cellId: number | null = null;
    private title: string = '';
    private reference: string = '';
    private skipNextAutoTrigger: boolean = false;

    private readonly dutyApi = initClient(DutyClient);
    private readonly cellApi = initClient(CellClient);
    private readonly activityApi = initClient(ActivityControllerUIClient);

    mounted(): void {
        this.reloadAll();
    }

    async reloadAll(): Promise<void> {
        await this.reloadDuties();
        await this.reloadCells();
    }

    private async reloadDuties(): Promise<void> {
        const data = (await this.dutyApi.getDutiesWithNameAndCellIdsOnly()).result!
        this.duties.splice(0);
        this.duties.push(...data);
    }

    private async reloadCells(): Promise<void> {
        const data = await this.cellApi.getCellsAndTreeData();
        let tree = mapTree(data);
        this.cellTree.splice(0);
        this.cellTree.push(...tree);
    }

    openModal(): void {
        $('#' + this.modalId).modal('show');
        this.reset();
        setTimeout(() => (this.$refs.createButton as HTMLButtonElement).focus(), 500);
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    private reset(): void {
        this.dutyId = null;
        this.cellId = null;
        this.title = '';
        this.reference = '';
        this.skipNextAutoTrigger = false;
    }

    private async createActivity(): Promise<void> {
        if (!this.dutyId || !this.cellId) {
            return;
        }
        try {
            await this.activityApi.createActivityWithDutyAndCell(this.dutyId, this.cellId, this.skipNextAutoTrigger, this.title, this.reference);
            this.closeModal();
            this.$toasted.info(this.$t('txtCreated').toString());
            this.$emit('created');
        } catch (e) {
            this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e));
        }
    }

    private get cellsForVSelect(): { id: number, name: string }[] {
        let flatMapper = (tree: CellTree, prefix: string) => {
            return [{ id: tree.item.id!, name: prefix + tree.item.name! }].concat(tree.children.map(e => flatMapper(e, prefix + tree.item.name! + ' > ')).reduce((l, r) => l.concat(r), []));
        };
        return this.cellTree.map(e => flatMapper(e, '')).reduce((l, r) => l.concat(r), []);
    }

    private get dutiesForVSelect(): DutyNameWithCellIds[] {
        if (!this.cellId) {
            return [];
        }
        return this.duties.filter(e => e.cellIds.length === 0 || e.cellIds.includes(this.cellId!))
    }

    @Watch('cellId')
    private onCellIdChanged(): void {
        this.dutyId = null;
    }
}